import { render } from "./AboutVr.vue?vue&type=template&id=1ccbb4ad"
const script = {}

import "./AboutVr.vue?vue&type=style&index=0&id=1ccbb4ad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__